import { AfterViewInit, Component, OnDestroy, OnInit, inject } from '@angular/core';
import { UserService } from './core/user/user.service';
import { NotificationService } from './layout/common/notifications/services/notification.service';
import { Subject, combineLatest, interval, startWith, switchMap, takeUntil } from 'rxjs';
import { Role } from './core/constants/roles.enum';
import { AppVersionService } from './core/version/version.service';

@Component({
    selector   : 'app-root',
    templateUrl: './app.component.html',
    styleUrls  : ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {
    private _userService = inject(UserService);
    private _notificationService = inject(NotificationService);
    private _appVersionService = inject(AppVersionService);
    private _unsubscribeAll: Subject<void> = new Subject<void>();

    ngOnInit(): void {
        interval(60000 * 5)
            .pipe(
                startWith(0),
                switchMap(() => this._appVersionService.refreshVersionState()),
                takeUntil(this._unsubscribeAll)
            )
            .subscribe();
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            combineLatest([
                interval(60000 * 5).pipe(startWith(0)), // Every 5 minutes
                this._userService.user$,
            ])
                .pipe(takeUntil(this._unsubscribeAll))
                .subscribe(([, user]) => {
                if (user.role !== Role.VISITOR) {
                    this._notificationService.searchNotifications();
                }
            })
        }, 5000)
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }
}
